var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"form":_vm.form,"options":_vm.options,"licence":_vm.licence,"products":_vm.products,"submitting":_vm.submitting,"updating":!! _vm.data.active.vps,"selected-product":_vm.selectedProduct}})}
var staticRenderFns = []

export { render, staticRenderFns }